import DashboardSummaryTotalizers from "./components/SummaryTotalizers";
import useDashboardSummary from "./hooks/useDashboardSummary";
import DashboardChart from "./components/DashboardChart";
import DashboardHealth from "./components/DashboardHealth";
import useDashboardEvolution from "./hooks/useDashboardEvolution";

const Dashboard = () => {
  const { data: summary, isLoading: isSummaryLoading } = useDashboardSummary();
  const { data: evolution, isLoading: isEvolutionLoading } = useDashboardEvolution();

  return (
    <div className="flex flex-col gap-4">
      <div className="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
        <div className="flex flex-col">
          <p className="text-[20px] sm:text-[22px] font-bold text-ui-primary">Dashboard Global</p>
          <p className="text-[14px] text-ui-text-muted">Visão consolidada da operação da plataforma POUPenergia.</p>
        </div>
      </div>

      <DashboardSummaryTotalizers data={summary?.overview} isLoading={isSummaryLoading} />

      <div className="flex flex-col items-stretch gap-4 lg:flex-row">
        <DashboardChart className="flex-1" chartData={evolution} isLoading={isEvolutionLoading} />
        <DashboardHealth summary={summary} isLoading={isSummaryLoading} />
      </div>
    </div>
  );
};

export default Dashboard;
